import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import styles from "./VideoPage.module.scss";
import LivestreamService from "../../sevices2/LivestreamServices";
import PlaylistService from "../../sevices2/playlistServices";
import VideoOverviewCardV2 from "../../components/video/VideoOverviewCard/VideoOverviewCard";
import FollowButton from "../../components/FollowButton/FollowButton";
import SubscribeButton from "../../components/SubscribeButton/SubscribeButton";
import Auth from "../../components/auth/Auth/Auth";
import SubscribeModal from "../../components/Modals/SubscribeModal/SubscribeModal";
import UnsubscribeModal from "../../components/Modals/UnsubscribeModal/UnsubscribeModal";
const VideoPage = ({ darkMode }) => {
  const [signUpModeCalled, setSignUpModeCalled] = useState(false);
  const params = useParams();
  const [channelID, setChannelID] = useState(params["channelId"]);
  const [recordingID, setRecordingID] = useState(params.recordedStreamID);
  const [channel, setChannel] = useState({});
  const [video, setVideo] = useState({});
  const [similarPerspectives, setSimilarPerspectives] = useState([]);
  const [differentPerspectives, setDifferentPerspectives] = useState([]);
  const [login, setLogin] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [userPerms, setUserPerms] = useState("");
  const [isFollowing, setIsFollowing] = useState(false);

  const [showSubscriptionModal, setSubscriptionModal] = useState(false);
  const [unsubscribeModal, setuUnsubscribeModal] = useState(false);

  useEffect(() => {
    setChannelID(params["channelId"]);
    setRecordingID(params.recordedStreamID);
  }, [params]);

  function convertDateFormat(inputDate) {
    const date = new Date(inputDate);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(2);

    return `${month}/${day}/${year}`;
  }

    const toggleSubscriptionModalFun = () => {
      if (user?.access) {
        setSubscriptionModal((prev) => !prev);
      } else {
         handleOpenSignUp();
         return;
      }
    };
  
    const toggleUnsubscribeModal = () => {
      if (user?.access) {
        handleOpenSignUp();
        return;
      }
      setuUnsubscribeModal((prev) => !prev);
    };
  const getUserPerms = (channelID, access) => {
    LivestreamService.getUserPerms(channelID, access)
      .then((response) => {
        setUserPerms(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserPerms(user?.access, channelID);
  }, [channelID, user?.access]);

  function alreadyFollowing(channelID, access) {
    LivestreamService.getFollowingStatus(channelID, access)
      .then((response) => {
        setIsFollowing(response.message);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    alreadyFollowing(channelID, user?.access);
  }, [channelID, user?.access]);


  const followChannel = useCallback(
    (channelID, access, val) => {
      if (access) {
        fetch(`https://politix.tv/api/livestream/following/follow/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
          },
          body: JSON.stringify({
            value: val,
            channel_id: channelID,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if (isFollowing === true) {
              setIsFollowing(false);
            } else {
              setIsFollowing(true);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        handleOpenSignUp();
      }
    },
    [isFollowing]
  );

  const alignmentOptions = useMemo(
    () => ({
      0: "Left",
      1: "Somewhat Left",
      2: "Independent",
      3: "Somewhat Right",
      4: "Right",
    }),
    []
  );

  const [circleBackgroundColor, setCircleBackgroundColor] = useState("#a14bbb");
  const backgroundColors = useMemo(
    () => ({
      0: "#1877af", // Liberal (blue)
      1: "#5fa1c3", // Leaning Liberal (lighter blue)
      2: "#a14bbb", // Centrist (neutral gray)
      3: "#dba746", // Leaning Conservative (light orange)
      4: "#bc5100", // Conservative (red)
    }),
    []
  );
    const [signUp, setSignUp] = useState(null);
    const handleAuthClose = () => {
      setSignUp(false); //
    };
  
    const handleOpenSignUp = () => {
      setSignUp(true); 
    };
  const [alignment, setAlignment] = useState(null);
  const [margin, setMargin] = useState(50);

  const calculatePoliticalAlignment = useCallback(
    (social, economic) => {
      let alignmentCalculation = 2;
      if (social === "centrist") {
      } else if (social === "leaning_conservative") {
        alignmentCalculation += 1;
      } else if (social === "leaning_liberal") {
        alignmentCalculation -= 1;
      } else if (social === "conservative") {
        alignmentCalculation += 1;
      } else if (social === "liberal") {
        alignmentCalculation -= 2;
      }

      if (economic === "centrist") {
      } else if (economic === "leaning_conservative") {
        alignmentCalculation += 1;
      } else if (economic === "leaning_liberal") {
        alignmentCalculation -= 1;
      } else if (economic === "conservative") {
        alignmentCalculation += 1;
      } else if (economic === "liberal") {
        alignmentCalculation -= 2;
      }
      if (alignmentCalculation > 4) {
        alignmentCalculation = 4;
      }
      if (alignmentCalculation < 0) {
        alignmentCalculation = 0;
      }
      setAlignment(alignmentOptions[alignmentCalculation]);
      setCircleBackgroundColor(backgroundColors[alignmentCalculation]);
      if (alignmentCalculation === 0) {
        setMargin(2);
      } else if (alignmentCalculation === 4) {
        setMargin(98);
      } else {
        setMargin(alignmentCalculation * 25);
      }
    },
    [alignmentOptions]
  );

  const getPerspectives = useCallback((channelID) => {
    LivestreamService.getSimilarPerspectives(channelID)
      .then((response) => {
        const videos = [];
        for (let i = 0; i < response["message"].length; i++) {
          const video = {
            thumbnail: response["message"][i]["thumbnail"],
            pfp: response["message"][i]["avatar"],
            title: response["message"][i]["title"],
            desc: response["message"][i]["description"],
            channelID: response["message"][i]["channel"],
            name: response["message"][i]["channel_name"],
            date: convertDateFormat(
              response["message"][i]["date"].split("T")[0]
            ),
            id: response["message"][i]["playback_id"],
          };
          videos.push(video);
        }
        setSimilarPerspectives(videos);
      })
      .catch((error) => {
        console.log(error);
      });

    LivestreamService.getDifferentPerspectives(channelID)
      .then((response) => {
        const videos = [];
        for (let i = 0; i < response["message"].length; i++) {
          const video = {
            thumbnail: response["message"][i]["thumbnail"],
            pfp: response["message"][i]["avatar"],
            title: response["message"][i]["title"],
            desc: response["message"][i]["description"],
            channelID: response["message"][i]["channel"],
            name: response["message"][i]["channel_name"],
            date: convertDateFormat(
              response["message"][i]["date"].split("T")[0]
            ),
            id: response["message"][i]["playback_id"],
          };
          videos.push(video);
        }
        setDifferentPerspectives(videos);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getVideo = (user, channelID, recordingID) => {
    PlaylistService.getVideos(user, channelID, recordingID).then((response) =>
      setVideo(response[0])
    );
  };

  const [showDescription, setShowDescription] = useState(false);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);

   const learnMoreClick = () => {
     setShowDescription((prev) => !prev);
   };

   useEffect(() => {
     const handleClickOutside = (event) => {
       if (
         descriptionRef.current &&
         !descriptionRef.current.contains(event.target) &&
         buttonRef.current &&
         !buttonRef.current.contains(event.target)
       ) {
         setShowDescription(false);
       }
     };
     document.addEventListener("mousedown", handleClickOutside);
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
     };
   }, []);

  useEffect(() => {
    getVideo(user, channelID, recordingID);
  }, [channelID, recordingID, user]);

  const getChannel = useCallback(
    (channelID) => {
      LivestreamService.getChannel(channelID).then((data) => {
        const channel = {
          about: data.description,
          added_at: data.created_date,
          followers: data.followers,
          id: null,
          image: data.avatar,
          is_following: null,
          political_prof: data.political_prof,
          subscribers: data.subscribers,
          title: data.name,
          updated_at: data.updated_date,
          yt_id: null,
          yt_link: null,
          tags: data.tags,
          last_live: null,
        };
        if (data.political_prof["soc_pol"] && data.political_prof["econ_pol"]) {
          calculatePoliticalAlignment(
            data.political_prof["soc_pol"],
            data.political_prof["econ_pol"]
          );
        }
        setChannel(channel);
      });
    },
    [calculatePoliticalAlignment]
  );

  useEffect(() => {
    getChannel(channelID);
  }, [channelID, getChannel, recordingID]);

  useEffect(() => {
    if (user) {
      getUserPerms(channelID, user?.access);
    }
  }, [channelID, user, recordingID]);

  useEffect(() => {
    getPerspectives(channelID);
  }, [channelID, getPerspectives, recordingID]);

  const showSignUpModal = () => {
    setSignUpModeCalled((prev) => !prev);
  };

  const handleCopyUrl = () => {
    const currentUrl = window.location.href; // Get the current page URL
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        alert("URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.infoMobile}>
          <div className={styles.iframeContainer}>
            <iframe
              src={`https://lvpr.tv/?v=${params["recordedStreamID"]}&autoplay=0`}
              allowFullScreen
              allow="autoplay; encrypted-media; picture-in-picture"
              frameborder="0"
              sandbox="allow-same-origin allow-scripts"
              title="Livestream"
              className={styles.stream}
            />
          </div>
          <div
            className={styles.infoContainer}
            style={{ backgroundColor: darkMode ? "rgb(44, 44, 56)" : "" }}
          >
            <h3 className={styles.title}>{video?.title}</h3>

            <div className={styles.infoRow}>
              <div className={styles.buttonsContainer}>
                <Link
                  style={{ textDecoration: "none" }}
                  to={`/channel/${channelID}`}
                >
                  <img
                    className={styles.pfp}
                    src={channel["image"]}
                    alt="logo"
                  />
                </Link>
                <Link
                  style={{ textDecoration: "none", alignSelf: "center" }}
                  to={`/channel/${channelID}`}
                >
                  <h3
                    style={{
                      fontSize: "1.2rem",
                      color: "white",
                      margin: "0px 20px 0px 10px",
                    }}
                  >
                    {video.channel_name}
                  </h3>
                </Link>
              </div>

              <div className={styles.smallRow}>
                <FollowButton
                  isFollowing={isFollowing}
                  user={user}
                  followChannel={followChannel}
                  channelID={channelID}
                />

                <SubscribeButton
                  isSubscribed={userPerms["subscribed"]}
                  user={user}
                  userPerms={userPerms}
                  toggleSubscriptionModalFun={toggleSubscriptionModalFun}
                  toggleUnsubscribeModal={toggleUnsubscribeModal}
                />
              </div>
              <button className={styles.shareButton} onClick={handleCopyUrl}>
                Share
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 48 48"
                >
                  <path
                    fill="none"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="4"
                    d="M28 6h14v14m0 9.474V39a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h9m7.8 16.2L41.1 6.9"
                  />
                </svg>
              </button>
            </div>
            <div className={styles.videoInfo}>
              <p className={styles.videoDescription}>
                {video?.description ? (
                  video.description
                ) : (
                  <i>No Description Provided</i>
                )}
              </p>
              <p className={styles.date}>
                {Object.keys(video).length !== 0 &&
                  convertDateFormat(video.date)}
              </p>
            </div>
          </div>
        </div>
        {/* <ChatDiscussion
          showSignUpModal={() => showSignUpModal()}
          videoId={recordingID}
          style={{ width: "100% !important" }}
        /> */}
      </div>

      {channel?.political_prof?.soc_pol &&
        channel?.political_prof?.econ_pol && (
          <div className={styles.smallRow}>
            <div className={styles.politicalProfContainer}>
              <div
                className={styles.politicalProfile}
                style={{ backgroundColor: darkMode ? "rgb(44, 44, 56)" : "" }}
              >
                <div className={styles.headerRow}>
                  <div className={styles.grid}>
                    <div className={styles.center}>
                      <div className={styles.icon}></div>
                    </div>
                    <div className={styles.pataColumn}>
                      <p className={styles.pata}>PATA</p>
                      <p className={styles.pataFull}>Political Automated</p>
                      <p className={styles.pataTwo}>Transparency Assistant</p>
                    </div>
                  </div>
                  <h3 className={styles.politicalProfTitle}>
                    {channel["title"]} leans {alignment}
                  </h3>
                  <div
                    style={{
                      width: "30px",
                      justifyContent: "end",
                      display: "flex",
                      position: "relative",
                    }}
                  >
                    {showDescription && (
                      <div
                        className={styles.descriptionBox}
                        ref={descriptionRef}
                      >
                        <p>
                          The Politix Political Profile offers a high-level
                          overview of a user/creator's political beliefs.
                          <br />
                          <br />
                          It is helpful in making a general determination about
                          someone's perspectives and biases.
                          <br />
                          <br />
                          Knowing where others stand is crucial to transparency
                          and bridging the political divide.
                          <br />
                          <br />
                          While offering an accurate overview, please note that
                          it is only a high-level view. Everyone has many
                          nuances not reflected in their Political Profile.
                        </p>
                      </div>
                    )}
                    <button
                      className={styles.learnMoreButton}
                      onClick={learnMoreClick}
                      ref={buttonRef}
                    ></button>
                  </div>
                </div>
                <div className={styles.slider}>
                  <div
                    className={styles.arrow}
                    style={{
                      left: `${margin}%`,
                      backgroundColor: circleBackgroundColor,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        )}
      {showSubscriptionModal && (
        <SubscribeModal
          pfp={channel["image"]}
          channel={channel["title"]}
          access={user?.acces}
          channelID={channelID}
          closeModal={toggleSubscriptionModalFun}
        />
      )}

      {unsubscribeModal && (
        <UnsubscribeModal
          pfp={channel["pfp"]}
          channel={channel["title"]}
          access={user.acces}
          channelID={channelID}
          closeModal={toggleUnsubscribeModal}
        />
      )}

      {signUp === true && (
        <div className="signUp">
          <Auth
            disableAuthBtn={true}
            disableJoinBtn={true}
            modeDefault={"sign-up"}
            onClose={handleAuthClose}
          />
        </div>
      )}
      {similarPerspectives.length > 0 && (
        <>
          <h3
          className={styles.titleText}
            style={{
              color: darkMode ? "white" : "",
              
            }}
          >
            Similar Perspectives
          </h3>
          <div className={styles.perspectiveContainer}>
            {similarPerspectives.map((video, index) => (
              <VideoOverviewCardV2
                darkMode={darkMode}
                key={index + 6} // Adjusting the key to ensure uniqueness
                video={video}
                page="recordedStream"
                style={{
                  maxWidth: "100%",
                  marginLeft: "0px !important",
                  marginRight: "20px",
                }}
              />
            ))}
          </div>
        </>
      )}

      {differentPerspectives.length > 0 && (
        <>
          <h3 style={{ color: darkMode ? "white" : "" }}>
            Different Perspectives
          </h3>
          <div className={styles.perspectiveContainer}>
            {differentPerspectives.map((video, index) => (
              <VideoOverviewCardV2
                darkMode={darkMode}
                key={index + 6} // Adjusting the key to ensure uniqueness
                video={video}
                page="recordedStream"
                style={{
                  maxWidth: "100%",
                  marginLeft: "0px !important",
                  marginRight: "20px",
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default VideoPage;
